"use client"

import { useEffect } from "react"
import { usePathname, useSearchParams } from "next/navigation"

import { metaPixel } from "@/lib/analytics/meta-pixel"

/**
 * The only source of `PageView`. `/scripts/pixel.js` runs `init` and nothing
 * else, so the first page and every client-side navigation after it come
 * through this one effect — which is what keeps the entry page of a session
 * from being counted twice.
 *
 * The first call usually lands before the loader finishes; the queue in
 * `@/lib/analytics/meta-pixel` holds it until `onLoad`.
 *
 * Search params count as a navigation because they carry real state here
 * (`/checkout/[slug]?offer=…`). Reading them opts the subtree into client
 * rendering, hence the `<Suspense>` in `MetaPixel`.
 */
export function MetaPixelPageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const query = searchParams?.toString() ?? ""
  const url = query ? `${pathname}?${query}` : pathname

  useEffect(() => {
    metaPixel.pageView()
  }, [url])

  return null
}
